import { createContext, useState, useEffect, useContext } from 'react';
import notificheApi from '../api/notificheApi';
import { AuthContext } from '../auth/AuthContext';

export const NotificationContext = createContext();

export const NotificationProvider = ({ children }) => {
  const { user } = useContext(AuthContext); // prendo user dall’AuthProvider
  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    if (!user?.userId) return; // non aprire SSE se non loggato

    let unsubscribeFn = null;

    // --- FETCH INIZIALE ---
    const fetchNotifications = async () => {
      try {
        const data = await notificheApi.lista();
        console.log("Fetch iniziale notifiche:", data);
        setNotifications(data);
      } catch (err) {
        console.error('Errore fetch notifiche:', err);
      }
    };
    fetchNotifications();

    // --- SSE ---
    try {
      unsubscribeFn = notificheApi.subscribe(
        user.userId,
        (newNotification) => {
          console.log("Nuova notifica ricevuta:", newNotification);
          setNotifications((prev) => [newNotification, ...prev]);
        }
      );
    } catch (err) {
      console.error('Errore SSE:', err);
    }

    return () => {
      if (unsubscribeFn) unsubscribeFn();
    };
  }, [user?.userId]); // si riesegue al login/logout

  const markAsRead = async (notificaId) => {
    try {
      await notificheApi.markAsRead(notificaId);
      setNotifications((prev) =>
        prev.map((n) => (n.id === notificaId ? { ...n, letto: true } : n))
      );
    } catch (err) {
      console.error('Errore markAsRead:', err);
    }
  };

  const segnaTutteLette = async () => {
    try {
      await notificheApi.segnaTutteLette();
      setNotifications((prev) => prev.map((n) => ({ ...n, letto: true })));
    } catch (err) {
      console.error('Errore segnaTutteLette:', err);
    }
  };

  return (
    <NotificationContext.Provider
      value={{ notifications, markAsRead, segnaTutteLette }}
    >
      {children}
    </NotificationContext.Provider>
  );
};